import { LitElement, html, svg } from 'lit';

export class IconSorting16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Tekstliste med pil ned på siden</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M1 2h8M13 2v11.5M11 11.846 13 14l2-2.154M1 6h6M1 10h4M1 14h2"></path></svg>`; }
}
if (!customElements.get('f-icon-sorting16', IconSorting16)) {
  customElements.define('f-icon-sorting16', IconSorting16);
}